import { useLocation } from 'react-router';

import lang from '../../lib/language';

import { useIsMobile } from '../../hooks';
import NavButtons from '../NavigationButtons/NavButtons';

import FavouritesWatchList from './WatchListTable/FavouritesWatchList';
import PopularWatchList from './WatchListTable/PopularWatchList';

import styles from './WatchList.module.scss';

const WatchList = () => {
  const { isMobile } = useIsMobile();
  const location = useLocation();
  const locationState = location.state as { watchListTab?: number } | null;
  const initialTab = locationState?.watchListTab ?? 0;

  const tabs = [
    { text: lang.mobileWatchlistStocks(), component: <PopularWatchList sortingType={null} /> },
    { text: lang.commonFavourites(), component: <FavouritesWatchList sortingType={null} /> },
  ];

  return (
    <div className={styles.container}>
      <div className={isMobile ? styles.navigationWrapperMobile : styles.table}
      >
        <NavButtons initialActiveTab={initialTab} persistTabState="watchListTab" tabs={tabs} />
      </div>
    </div>
  );
};

export default WatchList;
